/*
 * @Author: LiaoYingLong
 * @Date: 2018-08-20 11:52:31
 * @Last Modified by:   LiaoYingLong
 * @Last Modified time: 2018-08-20 11:52:31
 */

<template>
  <div id="videoPlayer" v-if="visible" class="vbox">
    <div class="sbox">
      <div class="title" :style="{width:`${width}px`}">
        <div>{{title}}</div>
        <div class="close" @click="visible = false">
        </div>
      </div>
      <iframe frameborder="0" :width="width" :height="height" :src="videoSrc" allowfullscreen webkitallowfullscreen="true" scrolling="no"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      videoSrc: '',
      title: '',
      width: '600',
      height: '498',
    };
  },
};
</script>

<style lang="scss">
#videoPlayer {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  .sbox {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .title {
      background-color: #fff;
      width: 600px;
      height: 40px;
      box-sizing: border-box;
      line-height: 40px;
      margin: 0 auto;
      > div {
        display: inline-block;
        vertical-align: middle;
      }
      > div:first-child {
        float: left;
        padding: 0 16px;
      }
      .close {
        width: 32px;
        height: 40px;
        background-image: url('~@/common/img/icon.png');
        background-repeat: no-repeat;
        background-position: -356px 10px;
        cursor: pointer;
        float: right;
        margin-right: 8px;
      }
    }
  }
  .tcp-skin {
    margin: 0;
    width: 640px;
    overflow: hidden;
  }
  .video-js .vjs-tech {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
